<ng-container *transloco="let t">
  <pxw-action-sheet
    [hidden]="false"
    [label]="t('global.actions')"
    background="blue"
    appareance="solid"
    [cancelText]="t('global.cancel')"
    [width]="290"
  >
    <ng-template #buttonTemplate let-toggle="toggleActionSheet">
      @if (generatingCreditNote()) {
        <pxw-button
          size="sm"
          [rounded]="true"
          display="inline"
          color="silver"
          [disabled]="true"
          [loading]="true"
        >
          {{ t('Generando N/C') }}
        </pxw-button>
      } @else {
        @if (displayTaxVoucherType()) {
          <span class="tax-voucher-type"> {{ taxVoucherType() }}: </span>
        }
        <a class="ui-help-link voucher-ref" (click)="$event.stopImmediatePropagation(); toggle()">
          #{{ this.taxVoucherInput().details.voucherRef }}
        </a>
      }
    </ng-template>
    <pxw-button
      style="opacity: 0.8"
      size="md"
      appareance="link"
      color="blue"
      display="inline"
      (click)="onViewTaxVoucher(taxVoucherInput())"
    >
      <pxw-icon icon="eye" />
      {{ t('Ver comprobante') }}
    </pxw-button>
    <pxw-button
      style="opacity: 0.8"
      size="md"
      appareance="link"
      color="blue"
      display="inline"
      [disabled]="downloading()"
      (click)="onDownloadTaxVoucher(taxVoucherInput())"
    >
      <pxw-icon icon="arrow-down" />
      {{ t('Descargar comprobante') }}
    </pxw-button>
    <hr class="ui-separator ui-separator--sm" />
    <pxw-button
      style="opacity: 0.8"
      size="md"
      appareance="link"
      color="blue"
      (click)="$event.stopImmediatePropagation()"
    >
      <pxw-icon icon="print" />
      {{ t('Imprimir comprobante') }}
    </pxw-button>
    <div class="actions__submenu">
      <pxw-button
        size="md"
        appareance="link"
        color="blue"
        display="inline"
        (click)="onPrintTaxVoucher(taxVoucherInput())"
      >
        {{ t('Formato papel (A4)') }}
      </pxw-button>
      <pxw-button
        size="md"
        appareance="link"
        color="blue"
        display="inline"
        (click)="onPrintTaxVoucherTicket(taxVoucherInput())"
      >
        {{ t('Formato ticket') }}
      </pxw-button>
    </div>

    @if (displayCreditNoteAction()) {
      <hr class="ui-separator ui-separator--sm" />
      <pxw-button
        style="opacity: 0.8"
        size="md"
        appareance="link"
        color="pink"
        display="inline"
        (click)="onGenerateCreditNote()"
      >
        <pxw-icon icon="ban" />
        {{ t('Nota de crédito') }}
      </pxw-button>
    }
  </pxw-action-sheet>

  <pxw-modal-dialog
    #confirmCreditNoteDialog
    [title]="'Generar nota de crédito'"
    [confirmText]="'Generar'"
    [cancelText]="'Cancelar'"
    [type]="'confirm'"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>
        Se generará una nota de crédito para la factura
        <strong style="white-space: nowrap">#{{ taxVoucherInput().details.voucherRef }}.</strong>
      </p>
      <p>Esta acción no puede deshacerse.</p>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>

<!-- Prevents build error in ssr, due to pdf-viewer dependency -->
@defer {
  <pxw-pdf-modal-viewer
    [(pdfPreviewSrc)]="pdfPreviewSrc"
    [title]="'Comprobante fiscal'"
    [zoomIncrement]="0.1"
    (error)="onError($event)"
  />
}
